import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

export type SearchSummaryProps = {
  searchedAt: string;
  location?: string;
  work?: string;
  otherInfo?: string;
  keywords?: string;
  searchUrl: string;
};

type Props = SearchSummaryProps & {
  summaryGaLabel: string;
};

export const SearchSummary: FC<Props> = ({
  searchedAt,
  location,
  work,
  otherInfo,
  keywords,
  searchUrl,
  summaryGaLabel,
}) => {
  return (
    <dl className={styles.wrapper}>
      <dt className={styles.date} aria-label="検索日時">
        {searchedAt}
      </dt>
      <dd className={styles.content}>
        <a
          className={styles.link}
          href={searchUrl}
          data-ga-action="favorite_job_conditions_modal"
          data-ga-label={summaryGaLabel}
        >
          <dl className={styles.summaryList}>
            {location && (
              <>
                <dt className={styles.term}>
                  <Icon name="location" />
                </dt>
                <dd className={styles.description}>{location}</dd>
              </>
            )}
            {work && (
              <>
                <dt className={styles.term}>
                  <Icon name="job2" />
                </dt>
                <dd className={styles.description}>{work}</dd>
              </>
            )}
            {otherInfo && (
              <>
                <dt className={styles.term}>
                  <Icon name="square-split" />
                </dt>
                <dd className={styles.description}>{otherInfo}</dd>
              </>
            )}
            {keywords && (
              <>
                <dt className={styles.term}>
                  <Icon name="search" />
                </dt>
                <dd className={styles.description}>{keywords}</dd>
              </>
            )}
          </dl>
          <div className={styles.iconWrapper}>
            <Icon name="arrow-light-right" />
          </div>
        </a>
      </dd>
    </dl>
  );
};
